// @flow
import { connect } from 'react-redux';

import CardThumbail from 'components/fragments/card/CardThumbnail';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/fragments/card/CardThumbnail';

const mapStateToProps = (state: StateType): StateProps => ({
  clubName: state.settingsState.title,
  placeholder: state.settingsState.placeholder,
});

export default connect(mapStateToProps)(CardThumbail);
